/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboxArchiveAllResponse } from './InboxArchiveAllResponse';
import {
    InboxArchiveAllResponseFromJSON,
    InboxArchiveAllResponseFromJSONTyped,
    InboxArchiveAllResponseToJSON,
    InboxArchiveAllResponseToJSONTyped,
} from './InboxArchiveAllResponse';

/**
 * 
 * @export
 * @interface ArchiveAllInboxNotifications202Response
 */
export interface ArchiveAllInboxNotifications202Response {
    /**
     * 
     */
    data?: InboxArchiveAllResponse;
}

/**
 * Check if a given object implements the ArchiveAllInboxNotifications202Response interface.
 */
export function instanceOfArchiveAllInboxNotifications202Response(value: object): value is ArchiveAllInboxNotifications202Response {
    return true;
}

export function ArchiveAllInboxNotifications202ResponseFromJSON(json: any): ArchiveAllInboxNotifications202Response {
    return ArchiveAllInboxNotifications202ResponseFromJSONTyped(json, false);
}

export function ArchiveAllInboxNotifications202ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArchiveAllInboxNotifications202Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : InboxArchiveAllResponseFromJSON(json['data']),
    };
}

export function ArchiveAllInboxNotifications202ResponseToJSON(json: any): ArchiveAllInboxNotifications202Response {
    return ArchiveAllInboxNotifications202ResponseToJSONTyped(json, false);
}

export function ArchiveAllInboxNotifications202ResponseToJSONTyped(value?: ArchiveAllInboxNotifications202Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InboxArchiveAllResponseToJSON(value['data']),
    };
}

